import type {SketchDimensionSnapshot} from '../SketchDimensionTypes';

/**
 * 尺寸状态色解析（ROLE-004，对照 01 基线 §10.3）。
 *
 * 语义纪律：冲突（黄）与过定义/无解（红）是不同状态，禁止合并；
 * driven 灰色优先级低于错误态（悬空的 driven 仍显示棕色）。
 */

/** 状态色十六进制值。 */
const STATE_COLORS = {
    /** 欠定义（蓝）。 */
    underDefined: '#1e6fff',
    /** 完全定义（黑）。 */
    fullyDefined: '#1c1c1e',
    /** 从动/参考（灰）。 */
    driven: '#8a8a8f',
    /** 过定义/无解（红）。 */
    unsolvable: '#d43a3a',
    /** 冲突/无效（黄）。 */
    conflicting: '#d9a400',
    /** 悬空（棕）。 */
    dangling: '#8b5a2b',
} as const;

/**
 * 解析尺寸状态色。
 *
 * @param snapshot 尺寸快照。
 * @param options 渲染时机的补充事实：引用全部无法解析视同悬空（DANG-001 被动检测）。
 * @returns CSS 颜色值。
 */
export function resolveSketchDimensionStateColor(
    snapshot: SketchDimensionSnapshot,
    options?: {readonly referencesUnresolved?: boolean},
): string {
    if (options?.referencesUnresolved) {
        return STATE_COLORS.dangling;
    }
    switch (snapshot.solveState) {
        case 'dangling':
            return STATE_COLORS.dangling;
        case 'conflicting':
        case 'invalid':
            return STATE_COLORS.conflicting;
        case 'unsolvable':
        case 'redundant':
            return STATE_COLORS.unsolvable;
        default:
    }
    if (snapshot.role === 'driven') {
        return STATE_COLORS.driven;
    }

    return snapshot.solveState === 'fully-defined'
        ? STATE_COLORS.fullyDefined
        : STATE_COLORS.underDefined;
}
